/* Tiny browser-native event bus for cross-component WP-sync signals.
 *
 * The DataTable's inline-save success path dispatches `ol:edit-saved`
 * so the SyncHealthPill can immediately flip amber + speed up polling
 * without waiting for the next 30s tick. Also drives the floating
 * "Syncing N edit(s) to WordPress…" banner.
 *
 * Why not a React context: the publisher (DataTable per-cell save) and
 * the subscribers (pill + banner) live in different subtrees and the
 * existing code already uses `window` for navigation hints elsewhere.
 * A document-level event is the lowest-coupling answer that keeps each
 * component independently testable.
 */
export const WP_SYNC_EVENT = 'ol:edit-saved';

export function emitEditSaved(payload = {}) {
  try {
    window.dispatchEvent(new CustomEvent(WP_SYNC_EVENT, { detail: payload }));
  } catch { /* SSR / non-browser */ }
}

export function onEditSaved(handler) {
  const wrapped = (ev) => handler(ev.detail || {});
  window.addEventListener(WP_SYNC_EVENT, wrapped);
  return () => window.removeEventListener(WP_SYNC_EVENT, wrapped);
}
